import React, { useState, useRef, useEffect } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { Link, useHistory } from "react-router-dom";
import { Row, Col } from "reactstrap";
import QRCode from "qrcode.react";
import { CheckCircle, CurrencyRupee } from "react-bootstrap-icons";
import NewHeader from "../../Layouts/NewHeader";
import NewFooter from "../../Layouts/NewFooter";
import DataTable from "react-data-table-component";
import API from "../../helpers/API";
import NotificationManager from "../../components/Common/NotificationManager";
import BreadCrumb from "../../components/Common/BreadCrumb";

const customStyles = {
  table: {
    style: {
      minHeight: "170px",
      maxHeight: "100%",
      // overflowY: "scroll",
    },
  },

  headCells: {
    style: {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      marginTop: "10px",
      fontSize: "16px !important",
    },
  },

  cells: {
    style: {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      overflow: "none",
      minHeight: "47px",
      fontSize: "14px",
    },
  },
  headRow: {
    style: {
      background: "#ECECEC",
      fontWeight: "700",
      borderRadius: "10px 10px 0px 0px",
    },
  },
  rows: {
    style: {
      color: "#093564",
      border: "1px solid rgba(0, 0, 0, 0.10)",
      textTransform: "capitalize",
    },
  },

  pagination: {
    style: {
      color: "#000",
      backgroundColor: "#f3f3f9",
    },
  },
  noData: {
    background: "none",
    fontSize: "18px",
    color: "#888",
    textAlign: "center",
    padding: "20px",
  },
};

const ViewDetails = () => {
  const [loading, setLoading] = useState(false);
  const [showData, setShowData] = useState(false);
  const [logData, setLogData] = useState(null);

  const history = useHistory();
  const handleHistorySubmit = (values) => {
    setLoading(true);
    API.get(`/api/Consumer/History/${values.consumer_id}`)
      .then((res) => {
        console.log("responseee", res);
        const { data } = res;
        const sortedDataDescending = data?.sort((a, b) => {
          return new Date(b.timestamp) - new Date(a.timestamp);
        });
        setLogData(sortedDataDescending);
        setLoading(false);
        setShowData(true);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
        NotificationManager.error(
          "Consumer details",
          "Invalid Consumer number",
          3000,
          null,
          null,
          ""
        );
      });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        <NewHeader />
        <div
          className="mt-4 p-5"
          style={{
            background:
              "linear-gradient(180deg, rgba(23, 0, 0, 0.80) 28.15%, rgba(0, 11, 5, 0.80) 99.2%)",
            backdropFilter: "blur(30px)",
          }}
        >
          <h5 style={{ color: "#FFF", fontSize: "25px", fontWeight: "700" }}>
            Prepaid Electricity Recharge
          </h5>
          {localStorage.getItem("username") && <BreadCrumb />}
        </div>
        <div className="container mx-1" style={{ flex: "1" }}>
          <Grid container>
            <Grid item lg={9} xs={12}>
              <div
                className="card px-5 py-5 my-3 mx-2 m-auto shadow-lg position-relative"
                style={{
                  top: "-45px",
                  borderRadius: "10px",
                  margin: "auto !important",
                }}
              >
                <div>
                  <Formik
                    initialValues={{
                      consumer_id: "",
                    }}
                    validationSchema={Yup.object({
                      consumer_id: Yup.string().required("Required!"),
                    })}
                    onSubmit={handleHistorySubmit}
                  >
                    {({ values, errors, touched, setFieldValue }) => (
                      <Form className="av-tooltip tooltip-label-bottom">
                        <Grid>
                          {/*  Consumer Number */}
                          <Grid container spacing={2}>
                            <Grid item lg={8} xs={12} className=" mt-2 mb-2">
                              <div className="mb-3">
                                <label
                                  htmlFor="consumer_id"
                                  className="form-label"
                                  style={{
                                    color: "#9e9e9e",
                                    fontSize: "14px",
                                  }}
                                >
                                  Please enter your Consumer No or Meter No
                                  <span className="text-danger">*</span>
                                </label>
                                <Field
                                  className="form-control"
                                  name="consumer_id"
                                  placeholder="Consumer Number"
                                  style={{
                                    borderRadius: "0",
                                    border: "none",
                                    borderBottom: "1px solid #9e9e9e",
                                  }}
                                  onMouseOver={(e) =>
                                    (e.target.style.borderColor = "#26a69a")
                                  }
                                  onMouseOut={(e) =>
                                    (e.target.style.borderColor = "#9e9e9e")
                                  }
                                  onClick={(e) =>
                                    (e.target.style.borderColor = "#26a69a")
                                  }
                                  autocomplete="off"
                                />
                                <ErrorMessage
                                  name="consumer_id"
                                  render={(msg) => (
                                    <div className="text-danger">{msg}</div>
                                  )}
                                />
                              </div>
                              <div className="mb-3">
                                {loading ? (
                                  <div
                                    className="spinner-border"
                                    role="status"
                                    style={{ color: "rgba(40, 40, 40, 0.8)" }}
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                ) : (
                                  <div className="d-flex mt-4 mb-3 gap-2">
                                    <Button
                                      className="btn my-2 w-100"
                                      onClick={() => {
                                        history.push("/dashboard");
                                      }}
                                      style={{
                                        color: "black",
                                        fontWeight: 500,
                                        fontSize: "15px",
                                        background: "#D3D3D3",
                                        borderRadius: "5px",
                                        boxShadow:
                                          "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                                        textTransform: "capitalize",
                                      }}
                                      onMouseOver={(e) =>
                                        (e.target.style.background = "darkgrey")
                                      }
                                      onMouseOut={(e) =>
                                        (e.target.style.background =
                                          "lightgrey")
                                      }
                                    >
                                      Go Back
                                    </Button>
                                    <Button
                                      className="btn my-2 w-100 text-white font-weight-bold fs-15 rounded text-capitalize"
                                      type="submit"
                                      style={{
                                        background:
                                          "linear-gradient(90deg, #433232 5.56%, #383735 95.49%)",
                                        boxShadow:
                                          "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      View History
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                {logData && (
                  <div
                    className="mx-2 fs-16 fw-500"
                    style={{ borderRadius: "10px" }}
                  >
                    <DataTable
                      customStyles={customStyles}
                      columns={[
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Meter No
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div
                                title={value?.meterNo}
                                // style={{
                                //   whiteSpace: "nowrap",
                                //   overflow: "hidden",
                                //   textOverflow: "ellipsis",
                                //   maxWidth: "200px",
                                // }}
                              >
                                {/* {console.log("showwwwDaaata", showData)} */}
                                {value?.meterNo}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Token No
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div
                                title={value?.tokenNo}
                                // style={{
                                //   maxWidth: "max-content",
                                // }}
                              >
                                {value?.tokenNo}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Amount
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div
                                title={value?.rechargeAmount}
                                // style={{
                                //   whiteSpace: "nowrap",
                                //   textOverflow: "ellipsis",
                                //   maxWidth: "200px",
                                // }}
                              >
                                {value?.rechargeAmount}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Status
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div title={value?.job_title}>
                                {value?.paymentStatus}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Time
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div
                              // style={{
                              //   whiteSpace: "nowrap",
                              //   textOverflow: "ellipsis",
                              //   maxWidth: "200px",
                              // }}
                              >
                                {moment(value?.timestamp).format(
                                  "DD/MM/YYYY h:mm:ss A"
                                )}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                      ]}
                      data={logData}
                      noDataComponent={
                        <div className="text-center fs-18 fw-600 m-auto mt-5">
                          There are no records to display!
                        </div>
                      }
                      pagination={logData?.length > 5 ? true : false}
                      paginationPerPage={5}
                    />
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>

        <NewFooter />
      </div>
    </>
  );
};

export default ViewDetails;
